import ExecutaRest from '../util/ExecutaRest'

class campanhaApi {

    static gravar(campanha) {

        var rest = new ExecutaRest();
        
        return new Promise(function (resolve, reject) {

            rest.Post('CampanhaSL.svc/rest/GravarRespostaREST', campanha).then(retorno => {
                if (retorno.dado) {
                    resolve(Object.assign({}, retorno));
                } else if (retorno.erro) {
                    reject(retorno.erro);
                }
            }).catch(error => {
                reject('Ocorreu um erro inesperado em --> listarUF: ' + error /*areaTratamento.statusText*/);
            });

        });
        
    }

    static obterCampanhaPorToken(token) {

        var rest = new ExecutaRest();
        
        return new Promise(function (resolve, reject) {

            rest.Post('CampanhaSL.svc/rest/ObterCampanhaPorTokenREST', token).then(retorno => {
                if (retorno.dado) {
                    resolve(Object.assign({}, retorno));
                } else if (retorno.erro) {
                    reject(retorno.erro);
                }
            }).catch(error => {
                reject('Ocorreu um erro inesperado em --> obterCampanhaPorToken: ' + error /*areaTratamento.statusText*/);
            });

        });
        
    }

    static obterCampanhaPorIdCampanha(IdCampanha) {

        var rest = new ExecutaRest();
        
        return new Promise(function (resolve, reject) {

            rest.Post('CampanhaSL.svc/rest/ObterCampanhaPorIDREST', IdCampanha).then(retorno => {
                if (retorno.dado) {
                    resolve(Object.assign({}, retorno));
                } else if (retorno.erro) {
                    reject(retorno.erro);
                }
            }).catch(error => {
                reject('Ocorreu um erro inesperado em --> obterCampanhaPorIdCampanha: ' + error /*areaTratamento.statusText*/);
            });

        });
        
    }
}

 
 export default campanhaApi;


/** WEBPACK FOOTER **
 ** ./src/components/api/campanhaApi.js
 **/